module.exports = __webpack_public_path__ + "img/calendar.5bdc8294.svg";